/* ============================================================
   Papermill theme — collection and search filters
   The checkbox auto-submit lives in global.js; this file adds the rest.
   ============================================================ */
(function () {
  'use strict';

  var facets = document.getElementById('CollectionFacets');

  /* Mobile filter drawer */
  var openBtn = document.querySelector('[data-facet-open]');
  var closeBtn = document.querySelector('[data-facet-close]');
  if (openBtn && facets) openBtn.addEventListener('click', function () { facets.classList.add('active'); document.body.style.overflow = 'hidden'; });
  if (closeBtn && facets) closeBtn.addEventListener('click', function () { facets.classList.remove('active'); document.body.style.overflow = ''; });

  /* Price fields wait for the Apply button (or Enter) so typing "From" doesn't reload before "To" */
  document.querySelectorAll('[data-facet-manual]').forEach(function (el) {
    el.addEventListener('change', function (e) { e.stopPropagation(); });
  });

  /* Sorting keeps the filters already applied */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
